import {configureStore} from "@reduxjs/toolkit";
import smsSliceReducer from "./SendSms/SmsStore";
import themeSliceReducer from "./ThemeType"
import reviewAccountReducer from "./ReviewAccountsStore"
import submitDocumentFormReducer from "./SubmitDocumentForm"


const store = configureStore({
  reducer: {
    smsSliceReducer,
    themeSliceReducer,
    reviewAccountReducer,
    submitDocumentFormReducer

    //sellFactorRe
  }
});

export default store;